<div class="header-button" tappable (click)="clicked.emit()">
  <ng-content></ng-content>
</div>
